export function useTabs(activeTab) {
  const activeTabs = ref([]);

  const getActiveTab = (rowIndex) => {
    if (unref(activeTabs)[rowIndex]) {
      return unref(activeTabs)[rowIndex];
    }

    return unref(activeTab);
  };

  const setActiveTab = (activeTab, rowIndex) => {
    unref(activeTabs)[rowIndex] = activeTab;
  };

  return {
    getActiveTab,
    setActiveTab,
  };
}
